import {FetchResult} from '@apollo/client';
import {Dialog, DialogContent, DialogTitle} from '@mui/material';
import {ContactCategory, ContactMessage, UserAccount} from '../../__generated__/resolvers-types';
import ContactUsDialogForm from './ContactUsDialogForm';

export interface ContactUsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  categories: string[];
  user: UserAccount | null | undefined;
  handleSend: (
    name: string,
    email: string,
    category: ContactCategory,
    message: string,
    attachments: File[],
  ) => Promise<FetchResult<ContactMessage>>;
}

/**
 * Contact Us Dialog
 * @param isOpen - Whether the dialog is open
 * @param onClose - Function to call when the dialog is closed
 * @param categories - Array of categories
 * @param user - User account
 * @param handleSend - Function to call when the form is submitted
 * @returns Contact Us Dialog
 */
export default function ContactUsDialog({isOpen, onClose, categories, user, handleSend}: ContactUsDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Contact Us</DialogTitle>
      <DialogContent>
        <ContactUsDialogForm user={user} categories={categories} onSubmit={handleSend} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
}
